/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconAdd from '@telus-uds/palette-koodo/build/rn/icons/Add'
import PaletteIconClose from '@telus-uds/palette-koodo/build/rn/icons/Close'
const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#404040',
        borderColor: '#404040',
        borderWidth: 0,
        color: '#ffffff',
        iconBackground: '#404040',
        iconColor: '#ffffff',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderWidth: 0
      }
    },
    {
      if: { focus: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#000000',
        color: '#000000',
        iconBackground: 'rgba(0, 0, 0, 0)',
        iconColor: '#000000',
        outerBorderColor: '#000000',
        outerBorderGap: 3,
        outerBorderWidth: 1
      }
    },
    {
      if: { hover: true },
      tokens: {
        backgroundColor: '#404040',
        borderColor: '#404040',
        borderWidth: 0,
        color: '#ffffff',
        iconBackground: '#404040',
        iconColor: '#ffffff'
      }
    },
    {
      if: { selected: true },
      tokens: {
        backgroundColor: '#000000',
        borderColor: '#000000',
        color: '#ffffff',
        icon: PaletteIconClose,
        iconBackground: '#000000',
        iconColor: '#ffffff',
        iconPadding: 4,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderWidth: 0
      }
    },
    {
      if: { hover: true, selected: true },
      tokens: { backgroundColor: '#404040', iconBackground: '#404040' }
    },
    {
      if: { focus: true, selected: true },
      tokens: {
        backgroundColor: '#000000',
        outerBorderColor: '#000000',
        outerBorderWidth: 1
      }
    },
    {
      if: { focus: true, hover: true, selected: true },
      tokens: { backgroundColor: '#404040', iconBackground: '#404040' }
    },
    {
      if: { focus: true, pressed: true, selected: true },
      tokens: { backgroundColor: '#404040', iconBackground: '#404040' }
    },
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#efefef',
        borderWidth: 0,
        color: '#c9c8c8',
        iconBackground: '#efefef',
        iconColor: '#c9c8c8'
      }
    }
  ],
  tokens: {
    alignSelf: 'center',
    backgroundColor: '#ffffff',
    borderColor: '#000000',
    borderRadius: 4,
    borderWidth: 1,
    color: '#000000',
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '600',
    icon: PaletteIconAdd,
    iconAlignSelf: 'center',
    iconBackground: '#ffffff',
    iconBorderRadius: 32,
    iconColor: '#000000',
    iconPadding: 2,
    iconPosition: 'right',
    iconSize: 16,
    iconSpace: 2,
    iconTranslateX: 0,
    iconTranslateY: 0,
    lineHeight: 1.5,
    minWidth: 0,
    opacity: 1,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 2,
    outerBorderWidth: 0,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    shadow: null,
    textAlign: 'center'
  }
}
export default theme
